import { useState, useEffect } from "react";
import { loadIssueDetail } from "../services/issueIndentService";

const useLoadIssueDetailByRequestNumber=()=> {
    const [RequestIndentDetail, setRequestIndentDetail] = useState([]);   

    // Fetch department data
    const fetchIssueDetail = async (selectedID = null,request_indent_number) => {
        const para = { 
            p_companyid: localStorage.getItem("companyid"),
            p_plantid:1,
            p_id_request:selectedID,
            p_issue_indent_number:request_indent_number,
        };

        try {
            const data = await loadIssueDetail(para);
            if (data && data.length > 0) {
                setRequestIndentDetail(data);          

            }
            else {
                setRequestIndentDetail([]); // Clear the state if no data is returned
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };   

    // Function to load department based on selected ID
    const loadIssueDetailByRequestIndentID = async (selectedID,request_indent_number) => {
        await fetchIssueDetail(selectedID,request_indent_number);
    };

    return {
         RequestIndentDetail,       
         loadIssueDetailByRequestIndentID,
    };
};

export default useLoadIssueDetailByRequestNumber;
